<app-header></app-header>
<div class="image-container">
    <img src="assets/navimage.png" width="100%" alt="Your Image">
    <div class="image-text">
      <p>News</p>
    </div>
  </div>    

  <!-- <div class="container">
    <div class="d-flex justify-content-between mt-3">
      <div class="float-start">
        <strong><h2>News And Updates</h2></strong>
        <mat-divider style="background-color: black"></mat-divider>
      </div>
  
      <div class="border m-1 p-1 rounded opt">
        <mat-select  [(ngModel)]="selNewsRange" (selectionChange)="getNewsList()">
         
          <mat-option *ngFor="let range of newsrange" [value]="range">{{range.value}}</mat-option>
          
        </mat-select>
      </div>
    </div>
    
     
          <div class="row m-4">
              <div class="col-sm-6 p-0">
                  <img [src]="latestNews?.image?.fileUUID?imageBaseUrl+latestNews?.image?.fileUUID:defaultImg" alt="" width="250px" height="250px">
              </div>
              <div class="col-sm-6 owners p-0">
                  <div class="row">
                      <div class="col-sm-12 col-10">
                          <div class="px-4" >
                            <div class="d-flex">
                              <div class="label"><span style="font-size: small;"><b>{{latestNews?.category?.categoryName}}</b> . {{transformDate(latestNews?.publicationDate) }} | 
                              </span>
                            </div>
                            <div class="ms-1 align-items-center">
                              <span class="icon_color pointer"><mat-icon class="me-2">share</mat-icon>Share</span>
                            </div>
                            </div>
                              
                              <div class="heading blue"><b>{{latestNews?.newsTitle}}</b></div>
                              <div class="descp">
                                <div [innerHTML]="latestNews?.newsDescp"></div>
                              </div>
                              <div class="float-right mt-1 pointer">
                                  <a class="blue text d-flex" (click)="goToFullNews(latestNews)">Read More <mat-icon>arrow_forward</mat-icon></a>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
    
    
    <div class="container-fluid" >
      <div>
          <div class="row justify-content-between" *ngFor="let item of [].constructor(count); let i=index ">
              <div class="col-sm-5 m-3" *ngFor="let item1 of [].constructor(2); let j=index ">
                <div *ngIf="newsList2D[i] && newsList2D[i][j]">
                  <div>
                    <img [src]="newsList2D[i][j]?.image?.fileUUID?imageBaseUrl+newsList2D[i][j]?.image?.fileUUID:defaultImg" alt="" width="100%" height="250px">
                </div>
                <div >
                  <div class="label mt-2"><span style="font-size: small;">{{newsList2D[i][j]?.category?.categoryName}}.{{transformDate(newsList2D[i][j]?.publicationDate) }}</span></div>
                  <div class="title heading blue mt-2"><b>{{newsList2D[i][j]?.newsTitle}}</b></div>
                  <div>
                    <div class="descp1 mt-1" [innerHTML]="newsList2D[i][j]?.newsDescp"></div>
                  </div>
                  <div class="float-right mt-2 pointer">
                      <a class="blue text d-flex" (click)="goToFullNews(newsList2D[i][j])">Read More  <mat-icon>arrow_forward</mat-icon></a>
                  </div>
              </div>
                </div>
                
              </div>
          </div>
      </div>
   </div>
  </div> -->
  <app-footer></app-footer>